import type { SqlQuery } from './driver';

export type WorkerRequest =
  | { type: 'open'; file: string }
  | { type: 'query'; query: SqlQuery }
  | { type: 'batch'; queries: SqlQuery[] }
  | { type: 'close' }
  | { type: 'wipe' };

export type WorkerResponse =
  { id: number; ok: true; result: unknown } | { id: number; ok: false; error: string };

export interface RpcPort {
  postMessage(msg: unknown): void;
  addEventListener(type: 'message', cb: (e: MessageEvent) => void): void;
}

export function createRpc(port: RpcPort) {
  let next = 1;
  const pending = new Map<number, { resolve(v: unknown): void; reject(e: Error): void }>();
  port.addEventListener('message', (e) => {
    const msg = e.data as WorkerResponse;
    const p = pending.get(msg.id);
    if (!p) return;
    pending.delete(msg.id);
    if (msg.ok) p.resolve(msg.result);
    else p.reject(new Error(msg.error));
  });
  return {
    call<T>(req: WorkerRequest): Promise<T> {
      const id = next++;
      return new Promise<T>((resolve, reject) => {
        pending.set(id, { resolve: resolve as (v: unknown) => void, reject });
        port.postMessage({ id, ...req });
      });
    },
  };
}
